module.exports = __webpack_public_path__ + "static/media/med-yassine-ben-khalifa.382b3182.jpg";